exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button{background-color:#d94a38;border-radius:.3em;border:1px solid gray;color:#000;cursor:pointer;font-family:Courier;font-size:110%;font-weight:700;padding:10px 20px;transition:background-color .4s}button:hover{background-color:red}.tri-dugmeta button{max-width:30%;margin:.62em}.kockice{border-radius:20px;display:block;letter-spacing:.04em;margin-left:auto;margin-right:auto;padding:.3em;width:200px}.dugme-uranja{animation:uranja 10s;left:60%;position:relative}@keyframes uranja{0%{background:#ddd;left:0}to{background:#d94a38;left:60%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./game-ui/css/40-dugmici.css
// module id = 27
// module chunks = 0